import React, { createContext, useEffect, useRef } from "react";
import signalRService from "../services/signalrService";

export const SignalRContext = createContext(signalRService);

interface Props {
  children: React.ReactNode;
  isAuthenticated: boolean;
}

export const SignalRProvider: React.FC<Props> = ({ children, isAuthenticated }) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    const init = async () => {
      if (isAuthenticated && !isInitialized.current) {
        await signalRService.startConnection("notificationHub");
        await signalRService.startConnection("chatHub");

        isInitialized.current = true;
      }

      if (!isAuthenticated) {
        await signalRService.stopAllConnections();
        isInitialized.current = false;
      }
    };

    init();

    // ❌ REMOVE cleanup (important)
    // StrictMode will break your connection

  }, [isAuthenticated]);

  return (
    <SignalRContext.Provider value={signalRService}>
      {children}
    </SignalRContext.Provider>
  );
};